



















import { createComponent, inject } from "@vue/composition-api";
import ProductListUnitForm from "./ProductListUnitForm.vue";
import ListUnitTable from "@/components/ListUnitTable.vue";
import { ProductListUnit } from "@megarax/client/src/resources/plm";
import {
  sheetOptionsSymbol,
  SheetHighlights,
} from "@/components/sheet/SheetEntries";

interface Props {
  value: ProductListUnit[];
}

export default createComponent<Props>({
  components: { ListUnitTable },
  props: {
    value: { required: true },
  },
  setup(props, ctx) {
    const unitIsEqual = (a: ProductListUnit, b: ProductListUnit) =>
      a.product && b.product && a.product.activeId === b.product.activeId;

    const sheetHighlights = inject(sheetOptionsSymbol, {} as SheetHighlights);

    const getRowClass = ({ row: unit }: { row: ProductListUnit }) => {
      const unitHighlights = sheetHighlights["units"];
      if (unitHighlights)
        if (unitHighlights === true || unitHighlights[unit.product!.id!])
          return "table-warning";
    };

    return {
      unitFactory: () => new ProductListUnit(),
      ProductListUnitForm,
      unitIsEqual,
      getRowClass,
    };
  },
});
